module.exports = __webpack_public_path__ + "SP_SPT11-Pool-32f36ec75d6d1f80ff977cf118f96620.png";